import { Chip, Divider, Grid } from "@mui/material";
import Title1 from '../../components/title/title1';
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import NewspaperIcon from '@mui/icons-material/Newspaper';
import CustomPagination from '../../components/pagination/customPagination';
import BlogDetailsBox from "./blog-details-box";
import blogData from '../../data/blogs/en/blogs.json';
import FileNotFound from "../error/file-not-found";

const blogLocales = "blogs";
const ITEMS_PER_PAGE = 6;

const BlogList = () => {
    const {t} = useTranslation();

    const [activePage, setActivePage] = useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const changePage = useCallback((page) => {
        setActivePage(page);

        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Title1 
                title={t(`${blogLocales}.title`)} 
                description={t(`${blogLocales}.description`)}
                chipLabel={t(`${blogLocales}.chipTitle`)}
                chipIcon={<NewspaperIcon color="white"/>}
                chipColor="#2898d7"
            />

            <Divider 
                style={{
                    width:'100%',
                    display: blogData.length > 0 ? 'flex' : 'none'
                }}
            >
                <Chip label={`${blogData.length} ${t(`${blogLocales}.countSuffix`)}`} size="small" />
            </Divider>

            <Grid
                direction='row'
                justifyContent='center'
                alignItems='start'
                container
                spacing={{xs: 2, md: 5}}
                width='100%'
                sx={{
                    pt: 5
                }}
            >
                {
                    blogData.slice(activePage * ITEMS_PER_PAGE, ITEMS_PER_PAGE * (1 + activePage)).map((item, index) => {
                        return <Grid
                            key={index}
                            size={{xs: 12, md: 6, lg: 4}}
                        >
                            <BlogDetailsBox 
                                index={index}
                                img={item.image}
                                title={item.title}
                                description={item.description}
                                link={`/blog/${(activePage * ITEMS_PER_PAGE) + Number.parseFloat(index) + 1}`}
                            />
                        </Grid>
                    })
                }
            </Grid>

            {
                blogData.length === 0
                ?
                <FileNotFound 
                    icon="/images/icons/noBlogs.png"
                    description={t(`${blogLocales}.noBlogs`)}
                    iconSize={200}
                />
                :
                <></>
            }

            <CustomPagination 
                totalItems={blogData.length}
                itemsPerPage={ITEMS_PER_PAGE}
                activePage={activePage}
                onPageChange={changePage}
            />
        </>
    );
}

export default BlogList;